












































































































































































































































































































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'

import DigitalCurrency5AccountThumbnail from './digital-currency-5-account-thumbnail.vue'
import Input1TextInputForSearch from '../basic-type-3-input/input-1-text-input-for-search.vue'
import DigitalCurrency4PriceLabel from './digital-currency-4-price-label.vue'
import DigitalCurrency1DigitalCurrencySymbol from './digital-currency-1-digital-currency-symbol.vue'


import { TRANSACTION_TYPE_LIST } from './service-for-helper-constants/helper-constants-2'

import { projectVariables } from '../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import { getNumberWithFixedDecmial1 } from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-1-algorithms/algorithms-type-9-get-number-with-fixed-decimal/get-number-with-fixed-decimal-1'

import { DigitalCurrencyTransaction } from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-3-digital-currency-transaction/digital-currency-transaction-type-2-data-structures/data-structures-type-1-transaction/transaction-1'

// import { getUTCDate1 } from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-1-algorithms/algorithms-type-3-get-utc-date/get-utc-date-1'
// import { getMillisecondTimePartitionList1 } from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-1-algorithms/algorithms-type-4-get-millisecond-time-partition-list/get-millisecond-time-partition-list-1'

import { getDigitalCurrencyAmountWithCommaSeparatedValue } from './service-for-helper-algorithms/helper-algorithms-2-get-digital-currency-amount-with-comma-separated-value'

import moment from 'moment'

import {
  NUMBER_OF_MILLISECONDS_IN_A_YEAR,
  NUMBER_OF_MILLISECONDS_IN_A_MONTH,
  NUMBER_OF_MILLISECONDS_IN_A_DAY,
  NUMBER_OF_MILLISECONDS_IN_AN_HOUR,
  NUMBER_OF_MILLISECONDS_IN_A_MINUTE
} from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-1-general/general-type-3-constants/constants-3-time'

const namespace = 'digitalCurrency'

@Component({
  components: {
    DigitalCurrency5AccountThumbnail,
    Input1TextInputForSearch,
    DigitalCurrency4PriceLabel,
    DigitalCurrency1DigitalCurrencySymbol
  }
})
class DigitalCurrency3CreateTransaction extends Vue {

  @Prop({ default: null }) initialTransaction?: DigitalCurrencyTransaction

  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getServiceAccountDigitalCurrencyAccountList', { namespace }) getServiceAccountDigitalCurrencyAccountList?: any

  @Getter('getDigitalCurrencyAccount', { namespace }) getDigitalCurrencyAccount?: any

  @Action('getDigitalCurrencyAccountBySearchText', { namespace }) getDigitalCurrencyAccountBySearchText?: any
  @Action('createDigitalCurrencyTransaction', { namespace }) createDigitalCurrencyTransaction?: any

  initialCurrentDate: Date = new Date()

  digitalCurrencyName: string = projectVariables.digitalCurrencyName
  digitalCurrencySymbolImageIconUrl: string = projectVariables.digitalCurrencySymbolImageIconUrl

  senderAccountId: string = ''
  recipientAccountIdList: string[] = []
  onBehalfOfAccountId: string = ''
  currencyPaymentAmountList: number[] = [0]
  textMemorandum: string = ''

  isSendingTransactionAtCurrentDate: boolean = true
  transactionDate: string = ''
  transactionDateMenu: boolean = false

  transactionCancellationDate: string = ''
  transactionCancellationDateMenu: boolean = false

  transactionCancellationTimeMenu: boolean = false
  transactionCancellationTime: any = ''

  transactionType: any = TRANSACTION_TYPE_LIST[0].transactionName
  transactionTypeList: any[] = TRANSACTION_TYPE_LIST

  isSendingTransactionAtCurrentTime: boolean = true
  transactionTime: string = ''
  transactionTimeMenu: boolean = false

  isTransactionOnBehalfOfAnotherAccount: boolean = false
  isProductResourcePurchase: boolean = false
  isAccountContactInformationIncluded: boolean = false

  isRecurringTransaction: boolean = false

  timeUntilNextRecurrence: number = 1
  timeScaleForRecurrence: string = 'Day'
  timeScaleUnitSingularNameList: string[] = ['Minute', 'Hour', 'Day', 'Month', 'Year']
  timeScaleUnitPluralNameList: string[] = ['Minutes', 'Hours', 'Days', 'Months', 'Years']
  timeScaleUnitMillisecondList: number[] = [
    NUMBER_OF_MILLISECONDS_IN_A_MINUTE,
    NUMBER_OF_MILLISECONDS_IN_AN_HOUR,
    NUMBER_OF_MILLISECONDS_IN_A_DAY,
    NUMBER_OF_MILLISECONDS_IN_A_MONTH,
    NUMBER_OF_MILLISECONDS_IN_A_YEAR
  ]

  isUnlimitedNumberOfRecurrencePayments: boolean = true

  selectedSenderAccountSearchResult: any

  isValidCreateTransactionForm: any = null
  errorMessage: string = ''

  getDigitalCurrencyAmountWithCommaSeparatedValue = getDigitalCurrencyAmountWithCommaSeparatedValue
  getNumberWithFixedDecmial1 = getNumberWithFixedDecmial1

  @Watch('initialRecipientAccountId') onUpdateInitialRecipientAccountId () {
    //
  }

  @Watch('recipientAccountIdList') updateRecipientAccountIdList () {
    if (this.recipientAccountIdList.length < 1) {
      const accountRecipientId = this.initialTransaction ? Object.keys(this.initialTransaction.accountRecipientIdVariableTable || {})[0] : ''
      const initialDigitalCurrencyTransactionAmount = this.initialTransaction ? this.initialTransaction.accountRecipientIdVariableTable ? this.initialTransaction.accountRecipientIdVariableTable[accountRecipientId].transactionCurrencyAmount : 0 : 0
      const initialDigitalCurrencyTransactionAmount2 = this.initialTransaction ? this.initialTransaction.transactionCurrencyAmount : 0
      this.currencyPaymentAmountList = [this.currencyPaymentAmountList[0] || initialDigitalCurrencyTransactionAmount || initialDigitalCurrencyTransactionAmount2]
      return
    }
    this.currencyPaymentAmountList = [...new Array(this.recipientAccountIdList.length)].map((_value: any, index: number) => {
      const accountRecipientId = this.recipientAccountIdList[index]
      const initialDigitalCurrencyTransactionAmount = this.initialTransaction ? ((this.initialTransaction.accountRecipientIdVariableTable || {})[accountRecipientId] ? (this.initialTransaction.accountRecipientIdVariableTable[accountRecipientId].transactionCurrencyAmount) : 0) : 0
      return this.currencyPaymentAmountList[index] || initialDigitalCurrencyTransactionAmount
    })
  }

  @Watch('accountPageAccountId') onAccountPageAccountIdChange (newAccountId: string) {
    // if (newAccountId === this.getYourActiveDigitalCurrencyAccount.accountId) {
    //   this.recipientAccountId = ''
    // } else {
    //   this.recipientAccountId = newAccountId
    // }
    return newAccountId
  }

  @Watch('timeUntilNextRecurrence') onUpdateTimeScaleForRecurrence (newValue: any, _oldValue: any) {

    let indexOfScaleUnitValue = 0

    const indexOfNewValueScaleUnitSingularValue = this.timeScaleUnitSingularNameList.indexOf(this.timeScaleForRecurrence)
    const indexOfNewValueScaleUnitPluralValue = this.timeScaleUnitPluralNameList.indexOf(this.timeScaleForRecurrence)

    if (indexOfNewValueScaleUnitSingularValue >= 0) {
      indexOfScaleUnitValue = indexOfNewValueScaleUnitSingularValue
    } else if (indexOfNewValueScaleUnitPluralValue >= 0) {
      indexOfScaleUnitValue = indexOfNewValueScaleUnitPluralValue
    }

    if (parseInt(newValue, 10) === 1) {
      this.timeScaleForRecurrence = this.timeScaleUnitSingularNameList[indexOfScaleUnitValue]
    } else {
      this.timeScaleForRecurrence = this.timeScaleUnitPluralNameList[indexOfScaleUnitValue]
    }
  }

  get transactionPaymentAmount () {
    return this.currencyPaymentAmountList.reduce((value1: any, value2: any) => {
      return getNumberWithFixedDecmial1(getNumberWithFixedDecmial1(value1) + getNumberWithFixedDecmial1(value2))
    })
  }

  get timeScaleUnitList () {
    return parseInt(`${this.timeUntilNextRecurrence}`, 10) === 1 ? this.timeScaleUnitSingularNameList : this.timeScaleUnitPluralNameList
  }

  mounted () {
    this.senderAccountId = this.getActiveDigitalCurrencyAccount.accountId
    ;(this.$refs['create-transaction-form'] as any).resetValidation()

    const currentDate = (new Date())

    this.initialCurrentDate = currentDate

    this.onBehalfOfAccountId = this.initialTransaction ? this.initialTransaction.onBehalfOfAccountId || '' : ''
    this.isTransactionOnBehalfOfAnotherAccount = this.initialTransaction ? this.initialTransaction.onBehalfOfAccountId ? true : false : false
    this.isRecurringTransaction = this.initialTransaction ? this.initialTransaction.isRecurringTransaction || false : false
    this.timeUntilNextRecurrence = this.initialTransaction ? this.initialTransaction.originalTimeNumberUntilNextRecurrence || 1 : 1
    this.timeScaleForRecurrence = this.initialTransaction ? this.initialTransaction.originalTimeScaleUntilNextRecurrence || 'Day' : 'Day'
    this.textMemorandum = this.initialTransaction ? this.initialTransaction.textMemorandum || '' : ''
    this.transactionType = this.initialTransaction ? this.initialTransaction.transactionType || TRANSACTION_TYPE_LIST[0].transactionName : TRANSACTION_TYPE_LIST[0].transactionName
    this.isUnlimitedNumberOfRecurrencePayments = this.initialTransaction ? (this.initialTransaction.dateTransactionScheduledForCancellingRecurrence ? (new Date(this.initialTransaction.dateTransactionScheduledForCancellingRecurrence)).getTime() < currentDate.getTime() : true) : true
    this.transactionCancellationDate = this.initialTransaction ? moment(new Date(this.initialTransaction.dateTransactionScheduledForCancellingRecurrence ? (new Date(this.initialTransaction.dateTransactionScheduledForCancellingRecurrence)).getTime() >= currentDate.getTime() ? this.initialTransaction.dateTransactionScheduledForCancellingRecurrence : currentDate.getTime() : currentDate.getTime())).format('YYYY-MM-DD') : moment(currentDate).format('YYYY-MM-DD')
    this.transactionCancellationTime = this.initialTransaction ? moment(new Date(this.initialTransaction.dateTransactionScheduledForCancellingRecurrence ? (new Date(this.initialTransaction.dateTransactionScheduledForCancellingRecurrence)).getTime() >= currentDate.getTime() ? this.initialTransaction.dateTransactionScheduledForCancellingRecurrence : currentDate.getTime() + NUMBER_OF_MILLISECONDS_IN_A_MINUTE : currentDate.getTime() + NUMBER_OF_MILLISECONDS_IN_A_MINUTE)).format('HH:mm') : moment(currentDate.getTime() + NUMBER_OF_MILLISECONDS_IN_A_MINUTE).format('HH:mm')

    const dateTransactionScheduledForProcessing = new Date(this.initialTransaction ? ((new Date(this.initialTransaction.dateTransactionReScheduledForProcessing!)).getTime() || (new Date(this.initialTransaction.dateTransactionScheduledForProcessing!)).getTime()) >= currentDate.getTime() ? (this.initialTransaction.dateTransactionReScheduledForProcessing! || this.initialTransaction.dateTransactionScheduledForProcessing!) : currentDate.getTime() : currentDate.getTime())
    this.isSendingTransactionAtCurrentDate = this.initialTransaction ? dateTransactionScheduledForProcessing.getTime() <= currentDate.getTime() : true
    this.transactionDate = moment(dateTransactionScheduledForProcessing).format('YYYY-MM-DD')
    this.isSendingTransactionAtCurrentTime = this.initialTransaction ? dateTransactionScheduledForProcessing.getTime() <= currentDate.getTime() : true
    this.transactionTime = moment(dateTransactionScheduledForProcessing).format('HH:mm')
  }

  async sendPayment () {

    (this.$refs['create-transaction-form'] as any).validate()

    if (!this.isValidCreateTransactionForm) {
      this.errorMessage = 'Invalid Transaction Form'
      return
    } else {
      this.errorMessage = ''
    }

    const digitalCurrencyTransactionInformation = new DigitalCurrencyTransaction()
    const isScheduledForLaterProcessing = !this.isSendingTransactionAtCurrentDate || !this.isSendingTransactionAtCurrentTime

    if (isScheduledForLaterProcessing) {
      const scheduledTransactionDate = !this.isSendingTransactionAtCurrentDate ? this.transactionDateFormatted : moment(new Date()).format('YYYY-MM-DD')
      const scheduledTransactionTime = !this.isSendingTransactionAtCurrentTime ? this.transactionTime : moment(new Date()).format('HH:mm')
      digitalCurrencyTransactionInformation.dateTransactionScheduledForProcessing = ((new Date(`${scheduledTransactionDate} ${scheduledTransactionTime}`)).toISOString().split('.')[0] + 'Z')
    }

    digitalCurrencyTransactionInformation.accountRecipientIdVariableTable = {}
    digitalCurrencyTransactionInformation.accountSenderId = this.senderAccountId

    digitalCurrencyTransactionInformation.isRecurringTransaction = this.isRecurringTransaction
    digitalCurrencyTransactionInformation.onBehalfOfAccountId = this.onBehalfOfAccountId
    digitalCurrencyTransactionInformation.textMemorandum = this.textMemorandum
    digitalCurrencyTransactionInformation.transactionCurrencyAmount = this.transactionPaymentAmount
    digitalCurrencyTransactionInformation.transactionType = this.transactionType

    if (digitalCurrencyTransactionInformation.isRecurringTransaction) {
      digitalCurrencyTransactionInformation.millisecondRecurringDelay = this.getMillisecondRecurrenceDelay()
      digitalCurrencyTransactionInformation.originalTimeNumberUntilNextRecurrence = this.timeUntilNextRecurrence
      digitalCurrencyTransactionInformation.originalTimeScaleUntilNextRecurrence = this.timeScaleForRecurrence

      if (!this.isUnlimitedNumberOfRecurrencePayments) {
        digitalCurrencyTransactionInformation.dateTransactionScheduledForCancellingRecurrence = ((new Date(`${this.transactionCancellationDate} ${this.transactionCancellationTime}`)).toISOString().split('.')[0] + 'Z')
      }
    }

    for (let i = 0; i < this.recipientAccountIdList.length; i++) {
      const recpientAccountId = this.recipientAccountIdList[i]
      const currencyPaymentAmount = this.currencyPaymentAmountList[i]
      digitalCurrencyTransactionInformation.accountRecipientIdVariableTable[recpientAccountId] = {
        transactionCurrencyAmount: currencyPaymentAmount
      }
    }

    // Reset Form
    // ;(this.$refs['create-transaction-form'] as any).reset()
    this.emitToggleShowContent(false)

    this.createDigitalCurrencyTransaction(digitalCurrencyTransactionInformation).catch((errorMessage: any) => console.error(errorMessage))
  }

  updateAccountRecipientIdList (accountRecipientIdList: string[]) {
    this.recipientAccountIdList = accountRecipientIdList || []
  }

  getMillisecondRecurrenceDelay () {
    const indexOfSingular = this.timeScaleUnitSingularNameList.indexOf(this.timeScaleForRecurrence)
    const indexOfPlural = this.timeScaleUnitPluralNameList.indexOf(this.timeScaleForRecurrence)
    const baseTime = indexOfSingular >= 0 ? this.timeScaleUnitMillisecondList[indexOfSingular] : (indexOfPlural >= 0 ? this.timeScaleUnitMillisecondList[indexOfPlural] : 0)
    return this.timeUntilNextRecurrence * baseTime
  }

  requireSenderAccount (value: any) {
    return value ? true : 'Sender Account Required'
  }

  requireRecipientAccount (value: any) {
    return (value || []).length > 0 ? true : 'Recipient Account Required'
  }

  requireLessThanN1Characters (inputValue: any) {
    return (inputValue || '').length <= 1200 || 'Must have less than 1200 characters'
  }

  requireNonNegativePaymentAmount (paymentAmountValue: number) {
    return (getNumberWithFixedDecmial1(paymentAmountValue) > 0) || 'Payment Amount should be greater than 0'
  }

  requirePaymentToBeLessThanAccountBalance () {
    return (getNumberWithFixedDecmial1(this.transactionPaymentAmount) <= this.senderAccount.accountCurrencyAmount) || 'Payment Amount should be less than account balance'
  }

  requireRecurrentTimePeriodToBePositive (recurrentTimePeriodValue: number) {
    return (recurrentTimePeriodValue && recurrentTimePeriodValue > 0) || 'Time period should be a positive number'
  }

  requireScheduledDateAndTimeToBeGreaterThanCurrentTime () {
    const scheduledTransactionDate = !this.isSendingTransactionAtCurrentDate ? this.transactionDateFormatted : moment(this.initialCurrentDate).format('YYYY-MM-DD')
    const scheduledTransactionTime = !this.isSendingTransactionAtCurrentTime ? this.transactionTime : moment(this.initialCurrentDate).format('HH:mm')
    const dateTransactionScheduledForProcessing = (new Date(`${scheduledTransactionDate} ${scheduledTransactionTime}`)).getTime()
    return dateTransactionScheduledForProcessing >= this.initialCurrentDate.getTime() - NUMBER_OF_MILLISECONDS_IN_A_MINUTE || 'Scheduled Date should be greater than current time'
  }

  requireScheduledDateAndTimeToBeLessThanCancelledDateAndTime () {
    const scheduledTransactionDate = !this.isSendingTransactionAtCurrentDate ? this.transactionDateFormatted : moment(this.initialCurrentDate).format('YYYY-MM-DD')
    const scheduledTransactionTime = !this.isSendingTransactionAtCurrentTime ? this.transactionTime : moment(this.initialCurrentDate).format('HH:mm')
    const dateTransactionScheduledForProcessing = (new Date(`${scheduledTransactionDate} ${scheduledTransactionTime}`)).getTime()
    const dateTransactionScheduledForCancellingRecurrence = (new Date(`${this.transactionCancellationDate} ${this.transactionCancellationTime}`)).getTime()

    if (this.isRecurringTransaction && !this.isUnlimitedNumberOfRecurrencePayments) {
      return dateTransactionScheduledForProcessing < dateTransactionScheduledForCancellingRecurrence || 'Scheduled Date and Time should be greater than Cancellation Date and Time'
    }

    return true
  }

  get initialSelectedSenderAccountId () {
    return this.getActiveDigitalCurrencyAccount.accountId
  }

  // Initial Search Result List For Sender
  get serviceAccountList (): any[] {
    const digitalCurrencyAccountList: any[] = this.getServiceAccountDigitalCurrencyAccountList || []
    return digitalCurrencyAccountList.map((digitalCurrencyAccount: any) => {
      return {
        id: digitalCurrencyAccount.accountId,
        name: `${digitalCurrencyAccount.accountName} (@${digitalCurrencyAccount.accountUsername})`,
        icon: digitalCurrencyAccount.accountProfilePictureUrl
      }
    })
  }

  // Initial Selected Account Recipient

  get initialSelectedRecipientAccountList () {
    if (!this.senderAccountId || !this.initialTransaction || !this.initialTransaction.accountRecipientIdVariableTable) {
      return null
    }

    let accountRecipientIdVariableTable = Object.assign({}, this.initialTransaction.accountRecipientIdVariableTable)
    delete accountRecipientIdVariableTable[this.senderAccountId]

    if (Object.keys(accountRecipientIdVariableTable).length === 0) {
      return null
    }

    let digitalCurrencyAccountIdList: string[] = []

    for (let accountId in accountRecipientIdVariableTable) {
      if (!accountRecipientIdVariableTable.hasOwnProperty(accountId)) {
        continue
      }

      const digitalCurrencyAccount = this.getDigitalCurrencyAccount(accountId)

      if (!digitalCurrencyAccount || !digitalCurrencyAccount.accountId) {
        continue
      }

      digitalCurrencyAccountIdList.push(accountId)
    }

    return digitalCurrencyAccountIdList.length > 0 ? digitalCurrencyAccountIdList : null
  }

  // Initial Search Result List For Recipient
  get initialRecipientAccountList (): any[] {
    if (!this.senderAccountId || !this.initialTransaction || !this.initialTransaction.accountRecipientIdVariableTable) {
      return []
    }

    let accountRecipientIdVariableTable = Object.assign({}, this.initialTransaction.accountRecipientIdVariableTable)
    delete accountRecipientIdVariableTable[this.senderAccountId]

    let digitalCurrencyAccountList: any[] = []

    for (let accountId in accountRecipientIdVariableTable) {
      if (!accountRecipientIdVariableTable.hasOwnProperty(accountId)) {
        continue
      }

      const digitalCurrencyAccount = this.getDigitalCurrencyAccount(accountId)

      if (!digitalCurrencyAccount || !digitalCurrencyAccount.accountId) {
        continue
      }

      digitalCurrencyAccountList.push({
        id: digitalCurrencyAccount.accountId,
        name: `${digitalCurrencyAccount.accountName} (@${digitalCurrencyAccount.accountUsername})`,
        icon: digitalCurrencyAccount.accountProfilePictureUrl
      })
    }

    return digitalCurrencyAccountList
  }

  async getSearchResultList (searchText: string): Promise<any[]> {
    if (!searchText) {
      return []
    }

    const searchResultList = (await this.getDigitalCurrencyAccountBySearchText({ searchText })).filter((digitalCurrencyAccount: any) => digitalCurrencyAccount.accountId !== this.senderAccountId)

    return searchResultList.map((digitalCurrencyAccount: any) => {
      return {
        id: digitalCurrencyAccount.accountId,
        name: `${digitalCurrencyAccount.accountName} (@${digitalCurrencyAccount.accountUsername})`,
        icon: digitalCurrencyAccount.accountProfilePictureUrl
      }
    })
  }

  get recipientAccount (): any {
    // return this.getAccount(this.recipientAccountId)
    return {}
  }

  get senderAccount (): any {
    if (!this.getDigitalCurrencyAccount) {
      return null
    }
    return this.getDigitalCurrencyAccount(this.senderAccountId)
  }

  // Date formating
  get transactionDateFormatted () {
    return this.formatDate(this.transactionDate)
  }

  // Cancellation Date Formatted
  get transactionCancellationDateFormatted () {
    return this.formatDate(this.transactionCancellationDate)
  }

  formatDate (dateString: string): string {
    if (!dateString) return ''

    const [year, month, day] = dateString.split('-')
    return `${month}/${day}/${year}`
  }

  // Emit Toggle show content
  emitToggleShowContent (isVisible?: boolean) {
    this.$emit('toggleShowContent', { isVisible })
  }

  async scrollDown (isScrollDown?: boolean) {
    if (!isScrollDown) {
      return
    }
    if (!this.$refs['create-transaction-body-content']) {
      return
    }
    await new Promise((resolve) => setTimeout(resolve, 100))

    ;(this.$refs['create-transaction-body-content'] as any).scrollIntoView({ behavior: 'smooth', block: 'end' })
  }
}

export default DigitalCurrency3CreateTransaction
